<template>
  <div>
    <p class="text-2xl mb-6">Veille Globale - Configuration</p>

    <v-card class="mb-6 pa-2" outlined>
      <v-row class="ma-3">
        <v-col cols="12">
          <filters></filters>
        </v-col>
      </v-row>
    </v-card>

    <v-col cols="12" class="d-flex flex-row-reverse">
      <v-btn color="primary" @click="page.dialog = true">
        <v-icon class="mr-3">{{ icons.mdiPlusBox }}</v-icon
        >Nouvelle Configuration</v-btn
      >
    </v-col>

    <ConfigTable
      ref="configTable"
      @saved="handleSaved"
      @error="handleError"
      @warning="handleWarning"
    />

    <v-dialog v-model="page.dialog">
      <ConfigCreation
        @close-dialog="page.dialog = false"
        @saved="handleSaved"
        @error="handleError"
        @warning="handleWarning"
      />
    </v-dialog>
    <v-snackbar
      v-model="page.snackbar.show"
      :color="page.snackbar.status"
      timeout="3000"
      top
    >
      {{ page.snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script>
import { reactive } from "@vue/composition-api";
import { mdiPlusBox } from "@mdi/js";

import ConfigCreation from "@/components/news-radar/config/cards/ConfigCreation.vue";
import Filters from "@/components/news-radar/config/filters/Filters";
import ConfigTable from "@/components/news-radar/config/tables/ConfigTable.vue";

import useProxy from "@/hooks/useProxy";

export default {
  name: "NewsradarConfig",
  components: {
    ConfigTable,
    ConfigCreation,
    Filters,
  },
  setup(props, { emit }) {
    const { refs } = useProxy();

    const page = reactive({
      dialog: false,
      snackbar: {
        show: false,
        message: "",
        status: "success", // success|error|warning
      },
    });

    // =>  METHODS
    const handleSaved = async () => {
      page.snackbar.message = "Config créée avec succès";
      page.snackbar.status = "success";
      page.snackbar.show = true;
      refs.configTable.refreshList();
    };

    const handleError = async () => {
      page.snackbar.message =
        "Une erreur est survenue durant l'enregistrement... Si cela se reproduit, veuillez contacter l'administrateur du site.";
      page.snackbar.status = "error";
      page.snackbar.show = true;
      refs.configTable.refreshList();
    };

    const handleWarning = async (faulty_step) => {
      switch (faulty_step) {
        case "site-empty-error":
          page.snackbar.message =
            "Veuillez renseigner le site auquel cette configuration s'appliquera svp";
          break;

        case "source-empty-error":
          page.snackbar.message =
            "Veuillez renseigner la source concernée par cette configuration svp";
          break;

        case "name-empty-error":
          page.snackbar.message =
            "Veuillez donner un nom à cette configuration svp";
          break;

        case "entry-empty-error":
          page.snackbar.message =
            "Veuillez l'entrée que cette configuration devra traiter svp";
          break;

        case "entry-youtube-error":
          page.snackbar.message =
            'Une entrée pour un source Youtube doit ressembler à ceci : "https://www.youtube.com/@ChannelToFollow"';
          break;

        case "entry-reddit-error":
          page.snackbar.message =
            'Une entrée pour un source Reddit doit ressembler à ceci : "r/RedditChannel"';
          break;

        case "entry-rss-error":
          page.snackbar.message =
            'Une entrée pour un source Concurrency doit ressembler à ceci : "https://mon.flux/rss.xml"';
          break;

        case "entry-marfeel-error":
          page.snackbar.message =
            "Une entrée pour un source Marfeel doit être une chaîne JSON exportée depuis leur site";
          break;

        case "entry-instagram-error":
          page.snackbar.message =
            'Une entrée pour un source Instagram doit ressembler à ceci : "https://www.instagram.com/accountToFollow/"';
          break;

        case "entry-x-error":
          page.snackbar.message =
            'Une entrée pour un source X doit ressembler à ceci : "https://x.com/accountToFollow"';
          break;

        case "entry-tiktok-error":
          page.snackbar.message =
            'Une entrée pour un source Tiktok doit ressembler à ceci : "https://www.tiktok.com/accountToFollow/"';
          break;

        case "entry-linkedin-error":
          page.snackbar.message =
            'Une entrée pour une source LinkedIn doit ressembler à ceci : "https://www.linkedin.com/company/nom-entreprise" ou "https://www.linkedin.com/in/profil"';
          break;

        case "entry-website-error":
          page.snackbar.message =
            'Une entrée pour un source Website via RssApp doit ressembler à ceci : "https://website.url.to-parse"';
          break;

        case "media-type-error":
          page.snackbar.message =
            "Seules les sources Youtube, Instagram, X et Tiktok peuvent être suivies en vidéo";
          break;

        default:
          page.snackbar.message = "Un avertissement non supporté a été émis";
          break;
      }

      page.snackbar.status = "warning";
      page.snackbar.show = true;
      refs.configTable.refreshList();
    };

    // =>  COMPUTED

    // =>  WATCH

    // =>  HOOKS

    // =>  DATA
    return {
      handleError,
      handleSaved,
      handleWarning,
      icons: {
        mdiPlusBox,
      },
      page,
    };
  },
};
</script>

<style></style>
